import { ContextGLTextureFilter } from '../base/ContextGLTextureFilter';
import { ContextGLMipFilter } from '../base/ContextGLMipFilter';
import { ContextGLWrapMode } from '../base/ContextGLWrapMode';
/**
 * The same as SamplerState, but with strings
 * TODO: replace two similar classes with one
 */
var SoftwareSamplerState = /** @class */ (function () {
    function SoftwareSamplerState() {
        this.wrap = ContextGLWrapMode.REPEAT;
        this.filter = ContextGLTextureFilter.LINEAR;
        this.mipfilter = ContextGLMipFilter.MIPLINEAR;
    }
    return SoftwareSamplerState;
}());
export { SoftwareSamplerState };
export default SoftwareSamplerState;
